import { render, staticRenderFns } from "./AssumptionReportLegendCard.vue?vue&type=template&id=94cbb8da&scoped=true&"
import script from "./AssumptionReportLegendCard.vue?vue&type=script&lang=ts&"
export * from "./AssumptionReportLegendCard.vue?vue&type=script&lang=ts&"
import style0 from "./AssumptionReportLegendCard.vue?vue&type=style&index=0&id=94cbb8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cbb8da",
  null
  
)

export default component.exports